export enum AuthErrorCodes {
  B2CUserDoesNotExistError = 'AADB2C99002',
  B2CUserDoesxistError = 'AADB2C99001',
  LoginFailure = 'LoginFailure',
  None = 'None',
}
